import React from 'react';
import type { IconProps } from '../types';

export const AIIcon = (props: IconProps) => (
  <svg
    width="28px"
    height="28px"
    viewBox="0 0 512 512"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    className="iconify iconify--fxemoji"
    fill="#fff"
    {...props}
  >
    <g strokeWidth="0" />
    <g
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      className="small-sparkle-2"
      fill="#85a3ff"
      d="M210.3 65.5c28.8 7.3 51.4 29.9 58.7 58.7.7 2.8 4.3 2.8 5 0 7.3-28.8 29.9-51.4 58.7-58.7 2.8-.7 2.8-4.3 0-5-28.8-7.3-51.4-29.9-58.7-58.7-.7-2.8-4.3-2.8-5 0-7.3 28.8-29.9 51.4-58.7 58.7-2.8.7-2.8 4.3 0 5"
    />
    <path
      className="small-sparkle-1"
      fill="#6c7df9"
      d="M6.7 188.3c50.8 12.9 90.8 52.9 103.7 103.7 1.2 4.9 7.5 4.9 8.8 0 12.9-50.8 52.9-90.8 103.7-103.7 4.9-1.2 4.9-7.5 0-8.8C172 166.7 132 126.7 119.2 75.9c-1.2-4.9-7.5-4.9-8.8 0-12.9 50.8-52.9 90.8-103.7 103.7-4.9 1.2-4.9 7.5 0 8.7"
    />
    <path
      fill="#ff6b72"
      d="M180 350.7c76 19.3 135.9 79.1 155.1 155.1 1.9 7.3 11.3 7.3 13.1 0 19.3-76 79.1-135.9 155.1-155.1 7.3-1.9 7.3-11.3 0-13.1-76-19.3-135.9-79.1-155.1-155.1-1.9-7.3-11.3-7.3-13.1 0-19.3 76-79.1 135.9-155.1 155.1-7.3 1.8-7.3 11.2 0 13.1"
    />
  </svg>
);

export const STL3D = (props: IconProps) => (
  <svg
    width="28px"
    height="28px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g
      id="SVGRepo_bgCarrier"
      strokeWidth="0"
    />

    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    <g id="SVGRepo_iconCarrier">
      {' '}
      <path
        opacity="0.4"
        d="M22 9.75C21.59 9.75 21.25 9.41 21.25 9V7C21.25 4.42 19.58 2.75 17 2.75H7C4.42 2.75 2.75 4.42 2.75 7V9C2.75 9.41 2.41 9.75 2 9.75C1.59 9.75 1.25 9.41 1.25 9V7C1.25 3.56 3.56 1.25 7 1.25H17C20.44 1.25 22.75 3.56 22.75 7V9C22.75 9.41 22.41 9.75 22 9.75Z"
        fill="currentColor"
      />{' '}
      <path
        opacity="0.4"
        d="M17 22.75H7C3.56 22.75 1.25 20.44 1.25 17V15C1.25 14.59 1.59 14.25 2 14.25C2.41 14.25 2.75 14.59 2.75 15V17C2.75 19.58 4.42 21.25 7 21.25H17C19.58 21.25 21.25 19.58 21.25 17V15C21.25 14.59 21.59 14.25 22 14.25C22.41 14.25 22.75 14.59 22.75 15V17C22.75 20.44 20.44 22.75 17 22.75Z"
        fill="currentColor"
      />{' '}
      <path
        d="M16.3999 8.20999L12.6399 6.17996C12.2399 5.96996 11.7699 5.96996 11.3699 6.17996L7.60992 8.20999C7.33992 8.35999 7.16992 8.64995 7.16992 8.97995C7.16992 9.30995 7.33992 9.59997 7.60992 9.74997L11.3699 11.78C11.5699 11.89 11.7899 11.94 12.0099 11.94C12.2299 11.94 12.4499 11.89 12.6499 11.78L16.4099 9.74997C16.6799 9.59997 16.8499 9.30995 16.8499 8.97995C16.8399 8.64995 16.6699 8.35999 16.3999 8.20999Z"
        fill="currentColor"
      />{' '}
      <path
        d="M10.7402 12.4699L7.24023 10.7199C6.97023 10.5899 6.66022 10.6 6.40022 10.76C6.14022 10.92 5.99023 11.1899 5.99023 11.4899V14.7999C5.99023 15.3699 6.31024 15.89 6.82024 16.14L10.3202 17.89C10.4402 17.95 10.5702 17.9799 10.7102 17.9799C10.8702 17.9799 11.0202 17.9399 11.1602 17.8499C11.4202 17.6899 11.5702 17.4199 11.5702 17.1199V13.8099C11.5702 13.2399 11.2602 12.7299 10.7402 12.4699Z"
        fill="currentColor"
      />{' '}
      <path
        d="M17.5899 10.76C17.3299 10.6 17.0199 10.5899 16.7499 10.7199L13.2499 12.4699C12.7399 12.7299 12.4199 13.2399 12.4199 13.8099V17.1199C12.4199 17.4199 12.5699 17.6899 12.8299 17.8499C12.9699 17.9399 13.1199 17.9799 13.2799 17.9799C13.4099 17.9799 13.5399 17.95 13.6699 17.89L17.1699 16.14C17.6799 15.88 17.9999 15.3699 17.9999 14.7999V11.4899C17.9999 11.1899 17.8499 10.92 17.5899 10.76Z"
        fill="currentColor"
      />{' '}
    </g>
  </svg>
);

export const AISeg = (props: IconProps) => (
  <svg
    width="32px"
    height="32px"
    viewBox="0 0 28 28"
    fill="rgb(255 125 125)"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      id="SVGRepo_bgCarrier"
      strokeWidth="0"
    ></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      {' '}
      <path
        d="M3.84453 7.92226C2.71849 6.79623 2.71849 4.97056 3.84453 3.84453C4.97056 2.71849 6.79623 2.71849 7.92226 3.84453L20.1555 16.0777C21.2815 17.2038 21.2815 19.0294 20.1555 20.1555C19.0294 21.2815 17.2038 21.2815 16.0777 20.1555L3.84453 7.92226Z"
        stroke="#ffffff"
        strokeWidth="1.5"
      ></path>{' '}
      <path
        opacity="0.5"
        d="M6 10L10 6"
        stroke="#ffffff"
        strokeWidth="1.5"
        strokeLinecap="round"
      ></path>{' '}
      <path
        d="M16.1 2.30719C16.261 1.8976 16.8385 1.8976 16.9994 2.30719L17.4298 3.40247C17.479 3.52752 17.5776 3.62651 17.7022 3.67583L18.7934 4.1078C19.2015 4.26934 19.2015 4.849 18.7934 5.01054L17.7022 5.44252C17.5776 5.49184 17.479 5.59082 17.4298 5.71587L16.9995 6.81115C16.8385 7.22074 16.261 7.22074 16.1 6.81116L15.6697 5.71587C15.6205 5.59082 15.5219 5.49184 15.3973 5.44252L14.3061 5.01054C13.898 4.849 13.898 4.26934 14.3061 4.1078L15.3973 3.67583C15.5219 3.62651 15.6205 3.52752 15.6697 3.40247L16.1 2.30719Z"
        stroke="#6c7df9"
        className="small-sparkle-2"
        fill="#6c7df9"
      ></path>{' '}
      <path
        opacity="0.5"
        d="M19.9672 9.12945C20.1281 8.71987 20.7057 8.71987 20.8666 9.12945L21.0235 9.5288C21.0727 9.65385 21.1713 9.75284 21.2959 9.80215L21.6937 9.95965C22.1018 10.1212 22.1018 10.7009 21.6937 10.8624L21.2959 11.0199C21.1713 11.0692 21.0727 11.1682 21.0235 11.2932L20.8666 11.6926C20.7057 12.1022 20.1281 12.1022 19.9672 11.6926L19.8103 11.2932C19.7611 11.1682 19.6625 11.0692 19.5379 11.0199L19.14 10.8624C18.732 10.7009 18.732 10.1212 19.14 9.95965L19.5379 9.80215C19.6625 9.75284 19.7611 9.65385 19.8103 9.5288L19.9672 9.12945Z"
        stroke="#85a3ff"
        className="small-sparkle-1"
        fill="#85a3ff"
      ></path>{' '}
      <path
        opacity="0.5"
        d="M5.1332 15.3072C5.29414 14.8976 5.87167 14.8976 6.03261 15.3072L6.18953 15.7065C6.23867 15.8316 6.33729 15.9306 6.46188 15.9799L6.85975 16.1374C7.26783 16.2989 7.26783 16.8786 6.85975 17.0401L6.46188 17.1976C6.33729 17.2469 6.23867 17.3459 6.18953 17.471L6.03261 17.8703C5.87167 18.2799 5.29414 18.2799 5.1332 17.8703L4.97628 17.471C4.92714 17.3459 4.82852 17.2469 4.70393 17.1976L4.30606 17.0401C3.89798 16.8786 3.89798 16.2989 4.30606 16.1374L4.70393 15.9799C4.82852 15.9306 4.92714 15.8316 4.97628 15.7065L5.1332 15.3072Z"
        fill="#ff6b72"
        stroke="#ff6b72"
        className="small-sparkle-1"
      ></path>{' '}
    </g>
  </svg>
);

export const AIGallery = (props: IconProps) => (
  <svg
    width="32px"
    height="32px"
    viewBox="0 0 54 54"
    version="1"
    xmlns="http://www.w3.org/2000/svg"
    enableBackground="new 0 0 54 54"
    fill="#ffffff"
    stroke="#ffffff"
    {...props}
    strokeWidth="0.00048000000000000007"
  >
    <g
      id="SVGRepo_bgCarrier"
      strokeWidth="0"
    />

    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    />

    <g id="SVGRepo_iconCarrier">
      {' '}
      <path
        fill="#E65100"
        d="M41,42H13c-2.2,0-4-1.8-4-4V18c0-2.2,1.8-4,4-4h28c2.2,0,4,1.8,4,4v20C45,40.2,43.2,42,41,42z"
      />{' '}
      <path
        fill="#F57C00"
        d="M35,36H7c-2.2,0-4-1.8-4-4V12c0-2.2,1.8-4,4-4h28c2.2,0,4,1.8,4,4v20C39,34.2,37.2,36,35,36z"
      />{' '}
      <circle
        fill="#FFF9C4"
        cx="30"
        cy="16"
        r="3"
      />{' '}
      <polygon
        fill="#942A09"
        points="17,17.9 8,31 26,31"
      />{' '}
      <polygon
        fill="#BF360C"
        points="28,23.5 22,31 34,31"
      />{' '}
    </g>
  </svg>
);
